import { Alert, AlertDescription, AlertIcon, Button, HStack, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useListBidsForEventQuery, type SourcingEventDto } from "../../autogen/bff-api";

export const MissingContractsNotice = ({ event }: { event: SourcingEventDto }) => {
  const { t } = useTranslation();
  const { data, isLoading, isError, isFetching, refetch } = useListBidsForEventQuery({ eventId: event.id });

  if (isLoading) {
    return (
      <HStack spacing="2">
        <Spinner size="sm" color="smPrimary" />
        <Text fontSize="sm" color="smMuted">
          {t("Checking whether every winner has a contract…")}
        </Text>
      </HStack>
    );
  }

  if (isError) {
    return (
      <Alert status="warning" rounded="lg">
        <AlertIcon />
        <AlertDescription fontSize="sm">
          {t("We could not check whether every winner has a contract.")}{" "}
          <Button size="xs" variant="link" colorScheme="teal" onClick={() => void refetch()} isLoading={isFetching}>
            {t("Try again")}
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  const missing = (event.award?.winningBidIds ?? [])
    .flatMap((id) => (data?.bids ?? []).filter((bid) => bid.id === id))
    .filter((bid) => !bid.contractId)
    .map((bid) => bid.ownerName);
  if (missing.length === 0) return null;

  return (
    <Alert status="warning" rounded="lg">
      <AlertIcon />
      <AlertDescription fontSize="sm">
        {t(
          "{{suppliers}} has no contract yet. Once the procurement is completed, it can no longer be created from here.",
          { count: missing.length, suppliers: missing.join(", ") },
        )}
      </AlertDescription>
    </Alert>
  );
};
